<template>
    <div class="wrapper">
        <div class="image-wrap">
            <div class="image"></div>
            <div class="overlay" :class="{'inverse' : inverse}"></div>
        </div>
        <div class="homehero" :class="{'inverse' : inverse}">
            <wwdheader inverse></wwdheader>

            <div class="content">
                <h1
                    class="fade"
                    :class="{'fade-in-out' : fade}"
                >{{ $t(`pages.home.hero.${quotes[quoteIndex]}.title`) }}</h1>
                <h3
                    class="fade"
                    :class="{'fade-in-out' : fade}"
                >{{ $t(`pages.home.hero.${quotes[quoteIndex]}.body`) }}</h3>

                <!-- <button class="read-more">LEES MEER</button> -->
            </div>
        </div>
    </div>
</template>

<script>
import wwdheader from "@/components/wwdheader.vue";

export default {
    components: {
        wwdheader
    },
    data() {
        return {
            inverse: true,
            fade: false,
            quoteIndex: 0,
            quotes: ["slide_one", "slide_two", "slide_three"]
        };
    },

    mounted() {
        this.fader();
    },
    methods: {
        fader() {
            let time = 5000;
            let vm = this;
            let timer = setInterval(() => {
                vm.fade = true;

                setTimeout(() => {
                    vm.quoteIndex++;

                    if (vm.quoteIndex >= vm.quotes.length) {
                        vm.quoteIndex = 0;
                    }

                    vm.fade = false;
                }, 1000);
            }, time);
        }
    },

    props: {
        // inverse: Boolean
    }
};
</script>

<style scoped lang="scss">
.wrapper {
    width: 100%;
    height: 550px;
    position: relative;
    min-height: 500px;

    @media screen and (max-width: 950px) {
        height: unset;
        min-height: 650px;
    }

    .image-wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;

        z-index: -1;

        .image {
            width: 100%;
            height: 100%;
            background-image: url($asset_home);
            background-size: cover;
            background-position: center;
            position: absolute;
            top: 0;
            left: 0;

            z-index: -1;
        }

        .overlay {
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.35);

            &.inverse {
                background-color: rgba(0, 0, 0, 0.15);
            }
        }
    }
}

.homehero {
    padding: 40px;
    height: 100%;

    wddheader {
        position: absolute;
        top: 0;
    }

    .content {
        width: 100%;

        // position: absolute;
        // top: 0;
        // left: 0;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;

        @media screen and (max-width: 950px) {
            justify-content: flex-start;
            text-align: left;

            display: unset;
        }

        h1 {
            padding-top: 50px;
            margin-bottom: 25px;
            line-height: 72px;

            @media screen and (max-width: 950px) {
                line-height: 35px;
                text-align: left;
            }
        }

        h3 {
            margin-bottom: 60px;
            font-size: 18px;
            max-width: 80ch;
            font-weight: normal;
        }

        button {
            border: 0;
            padding: 15px;
            font-weight: 16px;
            color: white;
            background-color: black;
            font-weight: bold;
            letter-spacing: 1px;
        }
    }

    &.inverse {
        .content {
            color: white;
        }
    }
}

.fade {
    transition: opacity 0.5s ease;
    opacity: 1;
}

.fade-in-out {
    opacity: 0;
}
</style>
